export default __webpack_public_path__ + "static/brown-hairy-dog-671ed8b8fe5d69ee913f3aed3b7b66da.jpg";